export type SortDir = 'asc' | 'desc'

export function nextSortState(
  currentKey: string,
  currentDir: SortDir,
  field: string,
): { key: string; dir: SortDir } {
  if (currentKey === field) {
    return { key: field, dir: currentDir === 'asc' ? 'desc' : 'asc' }
  }
  return { key: field, dir: 'asc' }
}

export function compareSortValues(left: unknown, right: unknown): number {
  if (left == null || left === '') return right == null || right === '' ? 0 : 1
  if (right == null || right === '') return -1
  if (typeof left === 'number' && typeof right === 'number') {
    return left - right
  }
  return String(left).localeCompare(String(right), undefined, {
    numeric: true,
    sensitivity: 'base',
  })
}

export function sortRows<T>(
  rows: T[],
  getValue: (row: T) => unknown,
  dir: SortDir,
): T[] {
  return [...rows].sort((left, right) => {
    const result = compareSortValues(getValue(left), getValue(right))
    return dir === 'asc' ? result : -result
  })
}
